import React, { useCallback, useRef, useState, useEffect } from 'react';
import Webcam from 'react-webcam';
import { useWindowSize } from "@uidotdev/usehooks";

interface CameraFullProps {
	onCapture?: (img: string) => void; // Opcional: callback para receber a foto capturada
}

const CameraFull: React.FC<CameraFullProps> = ({ onCapture }) => {
	const size = useWindowSize();
	const webcamRef = useRef<Webcam>(null);
	const [capturedImage, setCapturedImage] = useState<string | null>(null);
	const [isCameraOpen, setIsCameraOpen] = useState(false);

	// const [ratio, setRatio] = useState(1.77);
	// const [width, setWidth] = useState(1080);
	// const [height, setHeight] = useState(1920);

	const height = size.height || 1920; // valor padrão para evitar divisão por zero
	const width = size.width || 1080; // valor padrão para evitar divisão por zero
	const isLandscape = height <= width;
	const ratio = isLandscape ? width / height : height / width;

	useEffect(() => {
		setIsCameraOpen(true);
	}, [])

	// useEffect(() => {
	// 	if (size) {

	// 		console.log('isLandscape', isLandscape);
	// 		console.log('width', width);
	// 		console.log('height', height);
	// 		setWidth(width);
	// 		setHeight(height);
	// 		setRatio(isLandscape ? width / height : height / width);
	// 	}
	// }, []);

	const capturePhoto = useCallback(() => {
		const imageSrc = webcamRef.current?.getScreenshot();
		if (imageSrc) {
			setCapturedImage(imageSrc);
			if (onCapture) {
				onCapture(imageSrc);
			}
		}
	}, [webcamRef]);

	const retakePhoto = () => {
		setCapturedImage(null);
	};

	const openCamera = () => {
		setIsCameraOpen(true);
	};

	const closeCamera = () => {
		setIsCameraOpen(false);
		setCapturedImage(null);
	};

	console.log('height', height);
	console.log('width', width);
	console.log('ratio', ratio);
	console.log('isLandscape', isLandscape);

	// const videoConstraints = {
	// 	facingMode: { exact: "environment" },
	// 	width: { ideal: window.innerWidth },
	// 	height: { ideal: window.innerHeight }
	// };

	// const videoConstraints = {
	// 	//width: 1080,
	// 	//height: 1920,
	// 	facingMode: "environment",
	// 	aspectRatio: ratio
	// };

	if (!isCameraOpen) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
				<button
					onClick={openCamera}
					style={{
						padding: '15px 30px',
						fontSize: '18px',
						backgroundColor: '#000000',
						color: 'white',
						border: 'none',
						borderRadius: '5px',
						cursor: 'pointer'
					}}
				>
					Abrir Câmera
				</button>
			</div>
		);
	}

	return (
		<div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
			{!capturedImage ? (
				<>
					<Webcam
						audio={false}
						ref={webcamRef}
						screenshotFormat="image/jpeg"
						videoConstraints={{ facingMode: "environment", aspectRatio: ratio }}
						//style={{ width: '100%', height: '100%', objectFit: 'cover' }}
						height={height}
						width={width}
						screenshotQuality={1}
					/>
					<div style={{
						position: 'absolute',
						bottom: '20px',
						left: '50%',
						transform: 'translateX(-50%)',
						display: 'flex',
						gap: '10px'
					}}>
						<button
							onClick={capturePhoto}
							style={{
								padding: '18px 24px',
								fontSize: '18px',
								backgroundColor: '#000000',
								border: 'none',
								borderRadius: '5px',
								cursor: 'pointer',
								color: '#ffffff'
							}}
						>
							Buscar Produto
						</button>
						{/* <button
							onClick={closeCamera}
							style={{
								padding: '10px 20px',
								fontSize: '18px',
								backgroundColor: 'red',
								color: 'white',
								border: 'none',
								borderRadius: '5px',
								cursor: 'pointer'
							}}
						>
							Fechar Câmera
						</button> */}
					</div>
				</>
			) : (
				<>
					<img
						src={capturedImage}
						alt="Captured"
						style={{ width: '100%', height: '100%', objectFit: 'cover' }}
					/>
					<div style={{
						position: 'absolute',
						bottom: '20px',
						left: '50%',
						transform: 'translateX(-50%)',
						display: 'flex',
						gap: '10px'
					}}>
						<button
							onClick={retakePhoto}
							style={{
								padding: '10px 20px',
								fontSize: '18px',
								backgroundColor: 'white',
								border: 'none',
								borderRadius: '5px',
								cursor: 'pointer'
							}}
						>
							Tirar Nova Foto
						</button>
						<button
							onClick={closeCamera}
							style={{
								padding: '10px 20px',
								fontSize: '18px',
								backgroundColor: 'red',
								color: 'white',
								border: 'none',
								borderRadius: '5px',
								cursor: 'pointer'
							}}
						>
							Fechar Câmera
						</button>
					</div>
				</>
			)}
		</div>
	);
};

export default CameraFull;
